const Heading2 = (props: React.HTMLAttributes<HTMLHeadingElement>) => {
  return <h2 className="text-2xl font-extrabold text-blue-700">{props.children}</h2>;
};

export default Heading2;
